import { render, staticRenderFns } from "./segmentationCheck.vue?vue&type=template&id=4affbc80"
import script from "./segmentationCheck.vue?vue&type=script&lang=js"
export * from "./segmentationCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports